import { writable } from 'svelte/store'

export class MapStore {
  constructor (store) {
    this.store = store || writable(new Map())
  }

  tx(fn) {
    this.store.update(map => {
      const newMap = new Map(map)
      fn(newMap)
      return newMap;
    })
  }

  set(key, value) {
    this.tx(map => map.set(key, value))
  }

  delete(key) {
    this.tx(map => map.delete(key))
  }

  clear() {
    this.store.set(new Map())
  }
}
